

import { updateObject } from '../../utils/updateObject'

type Props = {
  labelText: string
  fieldName: string,
  size?: 'big' | 'small',
  center?: boolean
  placeholder?: string
  setFormFields: React.Dispatch<React.SetStateAction<any>>
  formFields: ObjectStringKeyAnyValue
  formErrors: ObjectStringKeyAnyValue
  required?: boolean
}

function Text({
  labelText,
  fieldName,
  size,
  center,
  placeholder,
  setFormFields,
  formFields,
  formErrors,
  required = false
}: Props) {


  
  const classString = `
  bg-white drop-shadow-lg border border-gray-300 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full
  ${center ? 'text-center' : 'text-left'}
  ${size === 'big' && 'text-lg px-5 py-3'}
  ${size === 'small' && 'text-xs px-2 py-1'}
  ${size !== 'small' && size !== 'big' && 'text-sm px-3 py-2'}
  `

  return <div className={`${center ? 'text-center' : 'text-left'} w-full flex flex-col gap-2`}>
        {labelText && <p className={`${center ? 'text-center' : 'text-left'}`}>{labelText} {required && <span className={`text-red-600 font-bold`}>*</span>}</p>}
    <input
      className={classString}
      type='text'
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      value={formFields[fieldName] ? formFields[fieldName] : ''}
      onChange={(e) => updateObject(formFields, setFormFields, fieldName, e.target.value)}
    />
        {formErrors[fieldName] && <p className={`${center ? 'text-center' : 'text-left'} rounded p-1 bg-red-100 text-xs text-red-700`}>{formErrors[fieldName]}</p>}
  </div>
}
export default Text